import * as Sentry from '@sentry/react';
import { USER_SESSION_INFO } from '../okta';
import envConfig from '../config/config';

Sentry.init({
  dsn: envConfig.sentry.dsn,
  enabled: envConfig.sentry.enabled,
  environment: envConfig.sentry.environment,
  release: envConfig.sentry.release,
});

export class Logger {
  constructor(name) {
    this.name = name;
  }

  info(...args) {
    console.log(...args);
  }

  debug(...args) {
    console.debug(...args);
  }

  warn(...args) {
    console.warn(...args);
  }

  error(error, ...params) {
    console.error(error, ...params);
    const userInfo = window.sessionStorage.getItem(USER_SESSION_INFO);

    const sentryArgs = { tags: { ...params, userInfo, loggerName: this.name } };
    if (typeof error === 'string') {
      Sentry.captureMessage(error, sentryArgs);
    } else {
      Sentry.captureException(error, sentryArgs);
    }
  }
}

const logger = new Logger('default');

window.addEventListener('error', function (event) {
  logger.error(event.error);
});

export default logger;
